import { motion } from 'framer-motion';
import { HardHat, House, Drop, Thermometer, Wrench, Buildings, Lightning } from '@phosphor-icons/react';
import { useLang } from '@/context/LanguageContext';
import { SERVICES_LIST, UI_TEXT } from '@/data/tradeData';

const ICONS = { HardHat, House, Drop, Thermometer, Wrench, Buildings, Lightning };

export default function Services() {
  const { lang } = useLang();
  const t = UI_TEXT[lang].services;
  const services = SERVICES_LIST[lang];

  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#E31937] mb-4">{t.label}</p>
          <h2 className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-white max-w-xl">{t.title}</h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon];
            const num = String(i + 1).padStart(2, '0');
            return (
              <motion.div key={s.key} data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="service-cell p-8 lg:p-10 group cursor-default">
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-[#E31937]/30 font-display font-black text-3xl">{num}</span>
                  {Icon && <Icon size={28} weight="light" className="service-icon text-[#666] transition-colors duration-300" aria-hidden="true" />}
                </div>
                <h3 className="service-title font-display font-semibold text-lg text-white mb-2 transition-colors duration-300">{s.label}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
